import { FC, useState, useEffect } from "react";

import Table from "@components/Table/gradeTable";
import Modal from "@components/Modal";
import { IModal, IVersion } from "@types";
import { getVersionsColumns } from "../config";
import {
  ErrorServices,
  useFetchJobGradeVersionsQuery,
  useUpdateJobGradeVersionMutation,
} from "@services";
import { useTypedSelector } from "@hooks";

interface IGradeSetupVersions extends IModal {
  download: (id?: number | undefined) => void;
}

const GradeSetupVersions: FC<IGradeSetupVersions> = ({
  isVisible,
  setIsVisible,
  download,
}) => {
  const { company } = useTypedSelector(state => state.auth?.user!);
  const { id: company_id } = company!;
  const { data: versions, isLoading } = useFetchJobGradeVersionsQuery({
    page: 1,
    company_id,
  });
  const [updateJobGradeVersion] = useUpdateJobGradeVersionMutation();
  const { data } = versions || {};
  const [versionId, setVersionId] = useState<number | null>(null);

  useEffect(() => {
    if (data?.length) {
      const { id } = data?.find(
        (version: IVersion) => version?.is_active === "TRUE"
      );
      if (id) {
        setVersionId(id);
      }
    }
  }, [data]);

  const handleActive = async (id: number) => {
    try {
      setVersionId(id);
      await updateJobGradeVersion({ id, company_id }).unwrap();
    } catch (error) {
      ErrorServices(error);
    }
  };

  const versionsColumns = getVersionsColumns({
    handleActive,
    versionId,
    download,
  });
  return (
    <Modal
      mode="versions"
      footer={null}
      title="Previous Versions of Job Grades"
      isVisible={isVisible}
      width={855}
      setIsVisible={setIsVisible}
    >
      <div className="py-12">
        <Table
          isLoading={isLoading}
          data={data}
          columns={versionsColumns}
          pagination={false}
          customStyles="mx-4"
        />
      </div>
    </Modal>
  );
};

export default GradeSetupVersions;
